export default __webpack_public_path__ + "static/media/nyt-logo.ba45fbc4.jpg";